import NpdResult from '@/pages/NpdResult';

export default function NpdWrong() {
  return <NpdResult variant="wrong" />;
}
